import { all, put, takeLatest } from 'redux-saga/effects';
import {
    GET_ATTENDANCE_DASHBOARD_STATUS,
    GET_ATTENDANCE_DASHBOARD_STATUS_FAILURE,
    GET_ATTENDANCE_DASHBOARD_STATUS_SUCCESS,
} from '../../modules/constants';
import { defaultApi } from '../../utils/axiosApi';

export function* handleGetAttendanceDashboardStatus() {
    try {
        const url = `albait/dashboard/office-type-status/`;
        const response = yield defaultApi(url, 'GET');
        yield put({
            type: GET_ATTENDANCE_DASHBOARD_STATUS_SUCCESS,
            payload: { data: response },
        });
    } catch (err) {
        yield put({
            type: GET_ATTENDANCE_DASHBOARD_STATUS_FAILURE,
            payload: err,
        });
    }
}

export default function* root() {
    yield all([
        takeLatest(GET_ATTENDANCE_DASHBOARD_STATUS, handleGetAttendanceDashboardStatus),
    ]);
}
